// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F5jJm","col":"styles_col__3hoJt"};